"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=14271%3A296))
 * @trackcomponent
 * @lastsynced 2026-09-30T17:16:17.000Z
 * @optimized using svgo:^3.3.4
 */
export const BSRSynchronized = createSVGIcon(
  <path
    d="M16.567 5.95a.75.75 0 0 0-.171 1.491l.085-.745zm4.174 1.235-.085.745.786.09.048-.79zm1.007-4.235a.75.75 0 1 0-1.497-.09l.748.045zM7.463 18.148a.75.75 0 0 0 .377-1.452l-.189.726zM3.5 16.345l.188-.726-.766-.199-.157.776zm-1.586 4.053a.75.75 0 0 0 1.47.298l-.735-.149zm2.72-3.538a.75.75 0 0 0-1.269.802L4 17.26zm18.115-4.799a.75.75 0 0 0-1.5 0h1.5m-21 0a.75.75 0 0 0 1.5 0h-1.5m14.731-5.365-.085.745 4.26.49.085-.746.086-.745-4.26-.49zm4.26.489.749.045.258-4.28-.749-.045-.748-.045-.259 4.28zM7.651 17.422l.189-.726-4.15-1.077-.19.726-.187.726 4.15 1.077zm-4.15-1.077-.735-.15-.851 4.203.735.15.735.148.851-4.202zm8.749 5.466v-.75a9 9 0 0 1-7.616-4.2l-.634.4-.634.4a10.5 10.5 0 0 0 8.884 4.9zm9.75-9.75h-.75a9 9 0 0 1-9 9v1.5c5.799 0 10.5-4.701 10.5-10.5zm-9.75-10v.75c3.197 0 6.012 1.713 7.611 4.31l.64-.393.638-.394C19.284 3.323 16 1.311 12.25 1.311zm-9.75 10h.75c0-5.127 4.048-9.25 9-9.25v-1.5c-5.816 0-10.5 4.83-10.5 10.75z"
    fill="currentColor"
  />,
  "BSRSynchronized",
  {
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
